import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import AdvancedKidneyCareForABetterLife from "./sections/AdvancedKidneyCareForABetterLife";
import ServiceOfferingsGrid from "./sections/ServiceOfferingsGrid";
import ThePathToSuccess from "./sections/ThePathToSuccess";
import ServingTheHeartOfLeicestershire from "./sections/ServingTheHeartOfLeicestershire";
import ClientSuccessStories from "./sections/ClientSuccessStories";
import CommonTechQuestions from "./sections/CommonTechQuestions";
import SecureYourCompanion from "./sections/SecureYourCompanion";
import FooterInfo from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <AdvancedKidneyCareForABetterLife />
      <ServiceOfferingsGrid />
      <ThePathToSuccess />
      <ServingTheHeartOfLeicestershire />
      <ClientSuccessStories />
      <CommonTechQuestions />
      <SecureYourCompanion />
      <FooterInfo />
    </div>;
}